<template>
  <div>
    <div class="main_borrow">
      <el-dialog
        :visible.sync="showSelectReceptionDialog"
        :before-close="handleDialogClose"
        :title="$t('title.system.receptionistselection.topTitle')">
        <el-row>
          <el-col :span="20">
            <!-- hide-required-asterisk -->
            <el-form
              @submit.native.prevent
              :model="receptionistForm"
              ref="receptionistForm"
              label-width="138px"
              label-position="left"
              :rules="rules"
            >
              <el-row class="outside">
                <el-form-item
                  class="label"
                  :label="$t('label.popup.system.receptionist.person')"
                  prop="accountId"
                >
                  <el-select
                    v-model="receptionistForm.accountId"
                    :placeholder="$t('label.popup.system.receptionist.choose')"
                    @change="changeSelect"
                    @focus="initSelect"
                    class="select_box"
                  >
                    <el-option
                      v-for="(item, index) in selectOpts"
                      :key="index"
                      :label="item.fullname"
                      :value="item.accountId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
        <el-row class="text-center button_box">
          <glance-all @click="saveReception" class="setting_button">
            {{ $t("button.common.data.setup") }}
          </glance-all>
          <br />
          <cancelNarrowDown class="link-primary" @click="handleDialogClose">
            キャンセル
          </cancelNarrowDown>
        </el-row>
      </el-dialog>
    </div>
    <div>
      <el-dialog-prompt
        class="prompt-div"
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>
    </div>
  </div>
</template>

<script>
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import GlanceAll from "@/components/common/generalButton/GlanceAll";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import elDialogPrompt from "@/components/common/el-dialog-prompt";
import statusErrorCodeMsg from "@/utils/status-error-msg"
const EVENT_ON_SELECTED = "on-selected";

export default {
  name: "ReceptionistSelectionPopup",
  components: {
    GlanceAll,
    cancelNarrowDown,
    elDialogPrompt
  },
  props: {
    visible: Boolean,
    tenantId: String,
    accountList: Array,
  },
  watch: {
    visible: function (value) {
      this.showSelectReceptionDialog = value;
    },
  },
  data: function () {
    return {
      userList: null,
      msgParam: this.$t("message.common.settingConfirm",{
        field:"受付担当者"
      }),
      centerDialogVisibleIsShow: false,
      rules: {
        accountId: [
          {
            required: true,
            message: this.$t("label.popup.system.receptionist.choose"),
            trigger: ["blur", "change"],
          },
        ],
      },
      receptionistForm: {
        accountId: "",
        accountName: "",
      },
      selectOpts: [],
      showSelectReceptionDialog: this.visible,
    };
  },
  methods: {
    changeSelect(val) {
      if( val != null || val != undefined ) {
        for (let i = 0; i < this.accountList.length; i++) {
          if( val == this.accountList[i].accountId ) {
            this.userList = this.accountList[i]
          }
        }
      }
    },
    // 初始化select框
    initSelect() {
      this.selectOpts.length = 0;
      const recep = this.accountList;
      recep.forEach((item) => {
        this.selectOpts.push(item);
      });
    },
    isPassParam(param){
      if(param){
        this.doneCreatRec();
      }
    },
    saveReception() {
      this.$refs["receptionistForm"].validate((valid) => {
        if (valid) {
          this.centerDialogVisibleIsShow = true
          this.isPassParam();
        }
      });
    },
    doneCreatRec() {
      this.$emit("update:visible", false);

      // 关闭并清空dilag数据
      this.$nextTick(() => {
        this.$refs["receptionistForm"].resetFields();
      });
      this.showSelectReceptionDialog = false;

      // 调用API接口
      SystemManageApi.saveTenantReceInfo({
        tenantId: this.tenantId,
        accountId: this.receptionistForm.accountId,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if(statusErrorCodeMsg(data.statusCode, this, "BuildingCreate")) {
          this.$emit(EVENT_ON_SELECTED, this.userList);
          this.$messageIotSuccess(this.$t("message.common.settingSuccess",{
            field : this.$t("label.system.tenant.edit.manageUser")
          }));
        }
      });

    },
    handleDialogClose: function () {
      this.showSelectReceptionDialog = false;
      this.$emit("update:visible", false);
      this.$nextTick(() => {
        this.$refs["receptionistForm"].resetFields();
      });
    },
    created() {
      this.initSelect();
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin-left: 50px;
  margin-left: 50px;
  font-size: 24px;
  /* font-weight: bold; */
  color: #525250;
}

.outside {
  display: inline-block;
}
// 修改当前popup内部样式
.main_borrow {
  ::v-deep.el-dialog__header .el-dialog__headerbtn {
    // left: 28px !important;
    // right: auto !important;
    display: none; // 不展示顶部关闭按钮
  }
}
.main_borrow {
  ::v-deep.el-dialog {
    width: 566px;
    height: 382px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
  }
}
.main_borrow {
  ::v-deep.el-dialog__body {
    padding-top: 0;
    // padding-left: 76px;
    padding-bottom: 0;
  }
}
.main_borrow {
  ::v-deep .el-dialog__header .el-dialog__headerbtn .el-icon-close {
    font-size: 16px;
    margin-left: 0;
  }
}
.main_borrow {
  ::v-deep .el-dialog__headerbtn {
    top: 26px;
  }
}
.el-select{
  line-height: 42px;
  width: 332px;
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
  color: #fff;
  box-shadow: -2px -2px 5px #fff,
                 5px 5px 8px #E6E6E1;
  .el-input__inner{
    line-height: 24px;
    color: #525250;
    font-size: 15px !important;
    padding-left: 20px;
  }
  ::placeholder{
      color: #525250;
  }

}
::v-deep .el-input__inner{
  border: none;
  background: #F2F2ED;
  color: #525250;
  font-size: 15px !important;
}
::v-deep .el-icon-arrow-up:before {
  color: #525250;
}
.submit_button {
  margin-bottom: 30px;
}
.outside {
  ::v-deep.el-form-item__label::before{
    display: none;
  }
}
.button_box {
  margin-top: 90px;
}
.setting_button {
  ::v-deep.my-button{
     width: 292px;
  }

}
.outside{
  .el-form-item{
    margin-bottom: 0px;
  }
}
.prompt-div >.logout-style{
  ::v-deep .el-dialog {
    height: 164px !important;
    border-radius: 3px !important;
  }
}
</style>
